import type { PayloadAction } from "@reduxjs/toolkit";
import { User } from "../models/User";
import { createSlice } from "@reduxjs/toolkit";

export interface AuthState {
  user: null | User;
  initialized: boolean;
}

const initialState: AuthState = {
  user: null,
  initialized: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.initialized = true;
    },
    authChecked: (state) => {
      state.initialized = true;
    },
    logout: (state) => {
      state.user = null;
      state.initialized = true;
    },
  },
});

export const { login, authChecked, logout } = authSlice.actions;

export default authSlice.reducer;
